import Header from "./components/Header.jsx";
import StreamingUserInput from "./components/StreamingUserInput.jsx";
import ReviseItemInput from "./components/ReviseItemInput.jsx";
import SmartDiffInput from "./components/SmartDiffInput.jsx";
import QC3Input from "./components/QC3Input.jsx";
import Footer from "./components/Footer.jsx";
import AuthWrapper from "./components/AuthWrapper.jsx";

import { useState } from "react";

import { AppLayout, Tabs, ContentLayout } from "@cloudscape-design/components";
import "@cloudscape-design/global-styles/index.css";

import "./App.css";

function App() {
  const [selectedTopic, setSelectedTopic] = useState("validateItem");
  const [userInput, setUserInput] = useState({ initialPrompt: "" });

  function handleChange(inputIdentifier, newValue) {
    setUserInput((prev) => ({ ...prev, [inputIdentifier]: newValue }));
  }

  const renderInputComponent = (selectedTab) => (
    <StreamingUserInput
      userInput={userInput}
      onChange={handleChange}
      selectedTab={selectedTab}
    />
  );

  return (
    <div id="aws-app">
      <AuthWrapper>
        {({ userId, isSignedIn }) => (
          <>
            <header id="site-header">
              <Header userId={userId} isSignedIn={isSignedIn} />
            </header>
            <AppLayout
              content={
                <ContentLayout>
                  <div className="content-wrapper">
                    <Tabs
                      activeTabId={selectedTopic}
                      onChange={({ detail }) => setSelectedTopic(detail.activeTabId)}
                      tabs={[
                        { label: "Validate Item", id: "validateItem", content: renderInputComponent("Validate Item") },
                        { label: "Generate Rationale", id: "generateRationale", content: renderInputComponent("Generate Rationale") },
                        { label: "General", id: "general", content: renderInputComponent("General") },
                        { label: "Revise Item", id: "reviseItem", content: <ReviseItemInput /> },
                        { label: "SmartDiff", id: "smartDiff", content: <SmartDiffInput /> },
                        { label: "TE Assist", id: "qc3Review", content: <QC3Input /> },
                      ]}
                    />
                  </div>
                </ContentLayout>
              }
              navigationHide={true}
              toolsHide={true}
              maxContentWidth={1200}
            />
            <Footer />
          </>
        )}
      </AuthWrapper>
    </div>
  );
}

export default App;
